import { sendChildNeedsVisibilityRequest } from '../../hooks/useChildNeedsVisibility';

var goToAnchor = function goToAnchor(_ref) {
  var _window, _window$history;

  var target = _ref.target,
      elem = _ref.elem,
      behavior = _ref.behavior;
  sendChildNeedsVisibilityRequest(elem);

  if (!elem.scrollIntoView && window && window.location) {
    window.location.href = "#".concat(target);
    return;
  }

  setTimeout(function () {
    return elem.scrollIntoView({
      behavior: behavior,
      block: 'start',
      inline: 'nearest'
    });
  }, 150);

  if ((_window = window) !== null && _window !== void 0 && (_window$history = _window.history) !== null && _window$history !== void 0 && _window$history.pushState) {
    window.history.pushState({
      target: target
    }, undefined, "#".concat(target));
  }
};

export default goToAnchor;